import React from "react";
import BarcodeScannerComponent from "react-qr-barcode-scanner";

function BarQrScanner({onUpdateFn}) {
  const [data, setData] = React.useState("Scanning");

  return (
    <>
      <BarcodeScannerComponent
  

        width={400}
        height={300}
        onUpdate={(err, result) => {
          if (result){
            setData(result.text);
            onUpdateFn(result)
          }
         

         
        }}
    
      />
      <p className="mt-3">Scanning Result :- {data}</p>
    </>
  );
}

export default BarQrScanner;